interface IIsAllowedPrev {
  editMode: boolean;
  currentPageIndex: number;
}

export const isAllowedPrev = ({ editMode, currentPageIndex }: IIsAllowedPrev): boolean => {
  if (editMode) return false;
  if (currentPageIndex === 0) return false;
  return true;
};
